import { render, staticRenderFns } from "./AddEntityButton.vue?vue&type=template&id=a8f47304&scoped=true&"
import script from "./AddEntityButton.vue?vue&type=script&lang=js&"
export * from "./AddEntityButton.vue?vue&type=script&lang=js&"
import style0 from "./AddEntityButton.vue?vue&type=style&index=0&id=a8f47304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f47304",
  null
  
)

/* custom blocks */
import block0 from "./AddEntityButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports